'use client';

import { Divider, Padding, Typography } from '@musinsa/mds';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import { tv } from 'tailwind-variants';
import { getBrandConfig } from '../../../../common';
import { useAlphanumericInput } from '../../../../common/utils/inputValidation';

interface Props {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  className?: string;
}

const inputContainerVariants = tv({
  base: 'flex gap-0 py-[6px]! px-2 w-full border rounded items-center',
  variants: {
    hasError: {
      true: 'border-red focus-within:border-red',
      false: 'border-gray-300 focus-within:border-gray-500',
    },
  },
  defaultVariants: {
    hasError: false,
  },
});

export const AccountNameSection = ({ value, onChange, error, className }: Props) => {
  const { onKeyDown, onChange: handleInputChange } = useAlphanumericInput(onChange);
  const { service } = useDeviceInfo();
  const { shopUrlPrefix } = getBrandConfig(service);

  return (
    <div className={className}>
      <div className="flex flex-col py-2 gap-2">
        {/* Input Field with Prefix */}
        <div className="relative w-full">
          <div className={inputContainerVariants({ hasError: !!error })}>
            <span className="text-sm leading-5 text-black whitespace-nowrap">{shopUrlPrefix}</span>
            <input
              value={value}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={onKeyDown}
              placeholder="샵 주소"
              className="w-full text-sm leading-5 font-normal text-black placeholder:text-gray-400 border-none outline-none focus:border-none focus:outline-none"
              type="text"
            />
          </div>
        </div>

        {error && (
          <Typography variant="textEtc11pxReg" colorScheme="red">
            {error}
          </Typography>
        )}

        <div>
          <div className="flex items-start">
            <Typography className="px-1" variant="textEtc11pxReg" colorScheme="gray-500">
              •
            </Typography>
            <Typography variant="textEtc11pxReg" colorScheme="gray-500">
              샵 주소로 사용하고 싶은 고유 ID를 기입해 주세요.
            </Typography>
          </div>
          <div className="flex items-start">
            <Typography className="px-1" variant="textEtc11pxReg" colorScheme="gray-500">
              •
            </Typography>
            <Typography variant="textEtc11pxReg" colorScheme="gray-500">
              영문, 숫자 입력만 가능하며 공백이 적용되지 않습니다.
            </Typography>
          </div>
          <div className="flex items-start">
            <Typography className="px-1" variant="textEtc11pxReg" colorScheme="gray-500">
              •
            </Typography>
            <Typography variant="textEtc11pxReg" colorScheme="gray-500">
              주로 활용하시는 SNS 계정 ID를 추천합니다.
            </Typography>
          </div>
        </div>
      </div>
      <Padding y="4">
        <Divider variant="line" />
      </Padding>
    </div>
  );
};
